/* eslint-disable no-param-reassign */
import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Close, Angle } from 'utils/icon/icons';
import Image from '../utils/image';
import Panel from '../utils/panel';
import TrapFocus from '../utils/trap-focus';
import MultiGwpItem from './multi-gwp-item';

const GiftCounter = ({text, giftCountUsed, giftCountQualified}) => (
  <div className='mx-5'>
    <p className='text-headline-tag'>
      { text } <span>({ giftCountUsed }</span> / <span>{ giftCountQualified })</span>
    </p>
  </div>
)

const MultiGwpCta = ({
  multiGwpCtaGiftImg,
  multiGwpCtaDescription,
  multiGwpCtaBtnText,
  multiGwpPanelHeading,
  multiGwpProducts,
  multiGwpGiftCountQualified,
  multiGwpGiftCountUsed,
  setMultiGwpGiftCountUsed,
  multiGwpInCart
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [reachedMultiGwpLimit, setReachedMultiGwpLimit] = useState();

  setReachedMultiGwpLimit(multiGwpGiftCountUsed >= multiGwpGiftCountQualified);

  const panelTriggers = {
    openTriggerEl: document.querySelector('[data-multi-gwp-panel-trigger]'),
    closeTriggerEl: document.querySelector('[data-multi-gwp-panel-close]'),
    openTriggerEl2: document.querySelector('.multi-gwp-gift-trigger'),
    closeTriggerEl2: document.querySelector('[data-multi-gwp-panel-close-2]')
  }

  const multiGwpPanel = document.querySelector('[data-multi-gwp-panel]');

  let trapFocus = null;

  useEffect(() => {
    if (isOpen) {
      trapFocus = new TrapFocus(multiGwpPanel);
      trapFocus.init();
    }

    return () => {
      if (trapFocus) trapFocus.destroy(multiGwpPanel);
    };
  }, [isOpen]);

  useEffect(() => {
    if (reachedMultiGwpLimit) {
      setTimeout(() => {
        setIsOpen(false);
      }, 2000);
    }
  }, [reachedMultiGwpLimit])

  const handleAddToCart = (addToCartBtn, gwoQty) => {
    if (addToCartBtn.dataset.variantId === 'Limit Reached') return;

    const { subtitle } = addToCartBtn.dataset;
    const variant = { id: addToCartBtn.dataset.variantId };

    const attributes = [
      {
        key: '_is_gwp_product',
        value: true
      },
      {
        key: '_short_description',
        value: subtitle,
      }
    ];

    const payload = window.getPayload(variant, gwoQty);

    const addToCartEvent = new CustomEvent('cart:add', {
      detail: {
        payload: {
          ...payload,
          attributes
        },
      },
    });

    document.dispatchEvent(addToCartEvent);
    setMultiGwpGiftCountUsed(prevState => prevState + gwoQty);
  }

  return (
    <div className='bg-grey-6'>
      <div className='mx-5'>
        <div className='pt-4 pb-5'>
          <div className="flex items-center">
            <Image
              src={multiGwpCtaGiftImg}
              srcWidths={{ sm: 160, md: 400 }}
              classes='multi-gwp-gift-trigger hover:cursor-pointer basis-[70px] min-w-[70px] max-w-[70px] lg:basis-[90px] lg:max-w-[90px] cursor-pointer h-auto items-center'
            />
            <div className='flex flex-col'>
              <GiftCounter
                text={multiGwpCtaDescription}
                giftCountUsed={multiGwpGiftCountUsed}
                giftCountQualified={multiGwpGiftCountQualified}
              />
              <button
                className='button button--primary w-[100px] h-[40px] mt-2 mx-5'
                type='button'
                data-multi-gwp-panel-trigger
              >
                { multiGwpCtaBtnText }
              </button>
            </div>
          </div>
        </div>
        <Panel
          triggers={panelTriggers}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          additionalClasses="!max-w-none"
        >
          <div
            data-multi-gwp-panel
            className='relative'
          >
            <div className="flex justify-between py-5 border-b border-grey-4">
              <div className='mx-5 w-full flex justify-between'>
                <button
                  type="button"
                  data-multi-gwp-panel-close-2
                  aria-label={window.TMW.Strings.cart.close}
                  className='flex items-center gap-2 [&_svg]:-rotate-90'
                >
                  <Angle />
                  <p className='text-headline-tag'>BACK</p>
                </button>

                <button
                  type="button"
                  data-multi-gwp-panel-close
                  aria-label={window.TMW.Strings.cart.close}
                  className='flex items-center'
                >
                  <Close />
                </button>
              </div>
            </div>

            <div className='pt-5'>
              <GiftCounter
                text={multiGwpPanelHeading}
                giftCountUsed={multiGwpGiftCountUsed}
                giftCountQualified={multiGwpGiftCountQualified}
              />
            </div>
            <div className='mx-5'>
              {multiGwpProducts &&
                multiGwpProducts.map(product => (
                  <MultiGwpItem
                    key={product.id}
                    product={product}
                    handleAddToCart={handleAddToCart}
                    multiGwpInCart={multiGwpInCart}
                    reachedMultiGwpLimit={reachedMultiGwpLimit}
                    multiGwpGiftCountQualified={multiGwpGiftCountQualified}
                    multiGwpGiftCountUsed={multiGwpGiftCountUsed}
                  />
                ))
              }
            </div>

          </div>
        </Panel>
      </div>
    </div>
  )
}

export default MultiGwpCta;